import React from "react";

import classes from "./styles/style.module.css";

const TitleElement = ({ title, subtitle, desc }) => {
  return (
    <div className="my-4">
      <hr />
      <div className="d-flex">
        <p className={classes.formTitle}>{title}</p>
      </div>
      {subtitle && <p className={classes.subTitle}>{subtitle}</p>}
      {desc && <p className={classes.desc}>{desc}</p>}
    </div>
  );
};

export default TitleElement;
